import { Route, Routes } from "react-router-dom";
import EstudentCreate from "../pages/academic/EstudentCreate";
import EstudentsRegister from "../pages/academic/EstudentsRegister";
import GroupCreate from "../pages/academic/GroupCreate";
import GroupList from "../pages/academic/GroupList";
import GroupShow from "../pages/academic/GroupShow";
import ActivityCreate from "../pages/academic/ActivityCreate";
import ActivityShow from "../pages/academic/ActivityShow";
import PointCreate from "../pages/academic/PointCreate";
import BonoCreate from "../pages/academic/BonoCreate";
import GradeUp from "../pages/academic/GradeUp";
import GradeUpOne from "../pages/academic/GradeUpOne";
import GradeUpTwo from "../pages/academic/GradeUpTwo";
import GradeShow from "../pages/academic/GradeShow";
import BonoUpOne from "../pages/academic/BonoUpOne";
import BonoUpTwo from "../pages/academic/BonoUpTwo";
import EstudentEdit from "../pages/academic/EstudentEdit";
import GroupEdit from "../pages/academic/GroupEdit";
import ActivityEdit from "../pages/academic/ActivityEdit";
import StudentList from "../pages/academic/StudentList";
import StudentListShow from "../pages/academic/StudentListShow";
import PointUpdate from "../pages/academic/PointUpdate";


export default function AcademicDisplay() {
    // CreatePlanes
    return (
        <Routes>
            <Route path='createestudent/:group' element={<EstudentCreate />} />
            <Route path='editstudent/:group/:student' element={<EstudentEdit />} />
            <Route path='registerestudent/:group' element={<EstudentsRegister />} />
            <Route path='creategroup' element={<GroupCreate />} />
            <Route path='editgroup/:group' element={<GroupEdit />} />
            <Route path='listgroup' element={<GroupList />} />
            <Route path='showgroup/:id' element={<GroupShow />} />
            <Route path='createactivity/:group' element={<ActivityCreate />} />
            <Route path='editactivity/:group/:activity' element={<ActivityEdit />} />
            <Route path='createactivity/:group/:activity' element={<ActivityCreate />} />
            <Route path='showactivity/:id' element={<ActivityShow />} />
            <Route path='createpoint/:activity' element={<PointCreate />} />
            <Route path='updatepoint/:activity/:point' element={<PointUpdate />} />
            <Route path='createbono/:activity' element={<BonoCreate />} />
            <Route path='gradeup/:activity' element={<GradeUp />} />
            <Route path='gradeupone/:activity' element={<GradeUpOne />} />
            <Route path='gradeuptwo/:activity' element={<GradeUpTwo />} />
            <Route path='bonoupone/:activity/:bono' element={<BonoUpOne />} />
            <Route path='bonouptwo/:activity/:bono' element={<BonoUpTwo />} />
            <Route path='gradeshow/:activity' element={<GradeShow />} />
            <Route path='studentlist/:group' element={<StudentList />} />
            <Route path='studentlistshow/:group' element={<StudentListShow />} />
        </Routes>
    );
}